import { useEffect, useState } from 'react';

type MediaFile = File | string | null | undefined;

export const useMediaPreview = (
  mediaFile: MediaFile,
  mediaLink?: string | null,
) => {
  const [objectUrl, setObjectUrl] = useState<string | null>(null);

  useEffect(() => {
    if (!(mediaFile instanceof File)) {
      setObjectUrl(null);
      return;
    }
    const url = URL.createObjectURL(mediaFile);
    setObjectUrl(url);
    return () => URL.revokeObjectURL(url);
  }, [mediaFile]);

  if (typeof mediaFile === 'string' && mediaFile) return mediaFile;
  if (objectUrl) return objectUrl;
  return mediaLink ?? null;
};
